import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import AlertOutline16Svg from './AlertOutline16.svg.js';
import ArrowDownOutline16Svg from './ArrowDownOutline16.svg.js';
import ArrowLeftOutline16Svg from './ArrowLeftOutline16.svg.js';
import ArrowRightOutline16Svg from './ArrowRightOutline16.svg.js';
import ArrowUpOutline16Svg from './ArrowUpOutline16.svg.js';
import BadgeFilled16Svg from './BadgeFilled16.svg.js';
import CalendarOutline16Svg from './CalendarOutline16.svg.js';
import CancelledFilled16Svg from './CancelledFilled16.svg.js';
import CategoryOutline16Svg from './CategoryOutline16.svg.js';
import ChangeOutline16Svg from './ChangeOutline16.svg.js';
import CheckboxEmptyOutline16Svg from './CheckboxEmptyOutline16.svg.js';
import CheckboxMarkedFilled16Svg from './CheckboxMarkedFilled16.svg.js';
import CheckboxMarkedOutline16Svg from './CheckboxMarkedOutline16.svg.js';
import ChecklistOutline16Svg from './ChecklistOutline16.svg.js';
import CheckmarkOutline16Svg from './CheckmarkOutline16.svg.js';
import ChevronBackOutline16Svg from './ChevronBackOutline16.svg.js';
import ChevronDownOutline16Svg from './ChevronDownOutline16.svg.js';
import ChevronForwardOutline16Svg from './ChevronForwardOutline16.svg.js';
import ChevronUpOutline16Svg from './ChevronUpOutline16.svg.js';
import ClearFilled16Svg from './ClearFilled16.svg.js';
import ClearOutline16Svg from './ClearOutline16.svg.js';
import Co2Outline16Svg from './Co2Outline16.svg.js';
import CommentOutline16Svg from './CommentOutline16.svg.js';
import CommentFilled16Svg from './CommentFilled16.svg.js';
import ConfirmedFilled16Svg from './ConfirmedFilled16.svg.js';
import CopyOutline16Svg from './CopyOutline16.svg.js';
import CustomerServiceOutline16Svg from './CustomerServiceOutline16.svg.js';
import DeleteOutline16Svg from './DeleteOutline16.svg.js';
import DeliveryMethodOutline16Svg from './DeliveryMethodOutline16.svg.js';
import DeliveryOutline16Svg from './DeliveryOutline16.svg.js';
import DuplicationOutline16Svg from './DuplicationOutline16.svg.js';
import EditOutline16Svg from './EditOutline16.svg.js';
import EmailOutline16Svg from './EmailOutline16.svg.js';
import ErrorFilled16Svg from './ErrorFilled16.svg.js';
import EyeOutline16Svg from './EyeOutline16.svg.js';
import FacebookFilledSvg from './FacebookFilled.svg.js';
import FastTrackOutline16Svg from './FastTrackOutline16.svg.js';
import QuickPickupOutline16Svg from './QuickPickupOutline16.svg.js';
import FeedbackOutline16Svg from './FeedbackOutline16.svg.js';
import FilterOutline16Svg from './FilterOutline16.svg.js';
import GeolocationFilled16Svg from './GeolocationFilled16.svg.js';
import GeolocationOutline16Svg from './GeolocationOutline16.svg.js';
import GroceriesOutline16Svg from './GroceriesOutline16.svg.js';
import HeartOutline16Svg from './HeartOutline16.svg.js';
import HistoryOutline16Svg from './HistoryOutline16.svg.js';
import HomeDeliveryOutline16Svg from './HomeDeliveryOutline16.svg.js';
import IdOutline16Svg from './IdOutline16.svg.js';
import InfoFilled16Svg from './InfoFilled16.svg.js';
import InfoOutline16Svg from './InfoOutline16.svg.js';
import InstagramOutlineSvg from './InstagramOutline.svg.js';
import LinkOutline16Svg from './LinkOutline16.svg.js';
import LoadingOutline16Svg from './LoadingOutline16.svg.js';
import LocateFilled16Svg from './LocateFilled16.svg.js';
import LocateOutline16Svg from './LocateOutline16.svg.js';
import LocationFilled16Svg from './LocationFilled16.svg.js';
import LocationMapOutline16Svg from './LocationMapOutline16.svg.js';
import LocationMapFilled16Svg from './LocationMapFilled16.svg.js';
import LocationOutline16Svg from './LocationOutline16.svg.js';
import LockFilled16Svg from './LockFilled16.svg.js';
import MapListOutline16Svg from './MapListOutline16.svg.js';
import MapOutline16Svg from './MapOutline16.svg.js';
import MinusOutline16Svg from './MinusOutline16.svg.js';
import ModifyOrderOutline16Svg from './ModifyOrderOutline16.svg.js';
import NaviOutline16Svg from './NaviOutline16.svg.js';
import NewOutline16Svg from './NewOutline16.svg.js';
import OpeningHoursOutline16Svg from './OpeningHoursOutline16.svg.js';
import PhoneOutline16Svg from './PhoneOutline16.svg.js';
import PlusOutline16Svg from './PlusOutline16.svg.js';
import PreventReplacementOutline16Svg from './PreventReplacementOutline16.svg.js';
import RadioActiveOutline16Svg from './RadioActiveOutline16.svg.js';
import RadioInactiveOutline16Svg from './RadioInactiveOutline16.svg.js';
import ReceiptOutline16Svg from './ReceiptOutline16.svg.js';
import ReloadOutline16Svg from './ReloadOutline16.svg.js';
import ReplaceOutline16Svg from './ReplaceOutline16.svg.js';
import RestaurantOutline16Svg from './RestaurantOutline16.svg.js';
import RiskIndicatorEmptyOutline16Svg from './RiskIndicatorEmptyOutline16.svg.js';
import RiskIndicatorFilled16Svg from './RiskIndicatorFilled16.svg.js';
import SCardOutline16Svg from './SCardOutline16.svg.js';
import SearchOutline16Svg from './SearchOutline16.svg.js';
import SettingsOutline16Svg from './SettingsOutline16.svg.js';
import SizeReduction16Svg from './SizeReduction16.svg.js';
import SmartListOutline16Svg from './SmartListOutline16.svg.js';
import SortingAscending16Svg from './SortingAscending16.svg.js';
import SortingDescending16Svg from './SortingDescending16.svg.js';
import StarFilled16Svg from './StarFilled16.svg.js';
import StarOutline16Svg from './StarOutline16.svg.js';
import StoreOutline16Svg from './StoreOutline16.svg.js';
import SunOutline16Svg from './SunOutline16.svg.js';
import ThreeDotsHorizontalOutline16Svg from './ThreeDotsHorizontalOutline16.svg.js';
import ThreeDotsHorizontalFilled16Svg from './ThreeDotsHorizontalFilled16.svg.js';
import ThreeDotsVerticalOutline16Svg from './ThreeDotsVerticalOutline16.svg.js';
import ThreeDotsVerticalFilled16Svg from './ThreeDotsVerticalFilled16.svg.js';
import TextAreaOutline16Svg from './TextAreaOutline16.svg.js';
import UserFilled16Svg from './UserFilled16.svg.js';
import UserOutline16Svg from './UserOutline16.svg.js';
import { Icon } from '../../components/Icon/Icon.js';

var AlertOutline16 = function AlertOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(AlertOutline16Svg, null)
  }));
};
var ArrowDownOutline16 = function ArrowDownOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ArrowDownOutline16Svg, null)
  }));
};
var ArrowLeftOutline16 = function ArrowLeftOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ArrowLeftOutline16Svg, null)
  }));
};
var ArrowRightOutline16 = function ArrowRightOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ArrowRightOutline16Svg, null)
  }));
};
var ArrowUpOutline16 = function ArrowUpOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ArrowUpOutline16Svg, null)
  }));
};
var BadgeFilled16 = function BadgeFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(BadgeFilled16Svg, null)
  }));
};
var CalendarOutline16 = function CalendarOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CalendarOutline16Svg, null)
  }));
};
var CancelledFilled16 = function CancelledFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CancelledFilled16Svg, null)
  }));
};
var CategoryOutline16 = function CategoryOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CategoryOutline16Svg, null)
  }));
};
var ChangeOutline16 = function ChangeOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChangeOutline16Svg, null)
  }));
};
var CheckboxEmptyOutline16 = function CheckboxEmptyOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CheckboxEmptyOutline16Svg, null)
  }));
};
var CheckboxMarkedFilled16 = function CheckboxMarkedFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CheckboxMarkedFilled16Svg, null)
  }));
};
var CheckboxMarkedOutline16 = function CheckboxMarkedOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CheckboxMarkedOutline16Svg, null)
  }));
};
var ChecklistOutline16 = function ChecklistOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChecklistOutline16Svg, null)
  }));
};
var CheckmarkOutline16 = function CheckmarkOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CheckmarkOutline16Svg, null)
  }));
};
var ChevronBackOutline16 = function ChevronBackOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronBackOutline16Svg, null)
  }));
};
var ChevronDownOutline16 = function ChevronDownOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronDownOutline16Svg, null)
  }));
};
var ChevronForwardOutline16 = function ChevronForwardOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronForwardOutline16Svg, null)
  }));
};
var ChevronUpOutline16 = function ChevronUpOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ChevronUpOutline16Svg, null)
  }));
};
var ClearFilled16 = function ClearFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ClearFilled16Svg, null)
  }));
};
var ClearOutline16 = function ClearOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ClearOutline16Svg, null)
  }));
};
var CommentFilled16 = function CommentFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CommentFilled16Svg, null)
  }));
};
var CommentOutline16 = function CommentOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CommentOutline16Svg, null)
  }));
};
var ConfirmedFilled16 = function ConfirmedFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ConfirmedFilled16Svg, null)
  }));
};
var CopyOutline16 = function CopyOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CopyOutline16Svg, null)
  }));
};
var CustomerServiceOutline16 = function CustomerServiceOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(CustomerServiceOutline16Svg, null)
  }));
};
var DeleteOutline16 = function DeleteOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DeleteOutline16Svg, null)
  }));
};
var DeliveryMethodOutline16 = function DeliveryMethodOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DeliveryMethodOutline16Svg, null)
  }));
};
var DeliveryOutline16 = function DeliveryOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DeliveryOutline16Svg, null)
  }));
};
var DuplicationOutline16 = function DuplicationOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(DuplicationOutline16Svg, null)
  }));
};
var EditOutline16 = function EditOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(EditOutline16Svg, null)
  }));
};
var EmailOutline16 = function EmailOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(EmailOutline16Svg, null)
  }));
};
var ErrorFilled16 = function ErrorFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ErrorFilled16Svg, null)
  }));
};
var EyeOutline16 = function EyeOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(EyeOutline16Svg, null)
  }));
};
var FacebookFilled16 = function FacebookFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FacebookFilledSvg, null)
  }));
};
var FastTrackOutline16 = function FastTrackOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FastTrackOutline16Svg, null)
  }));
};
var QuickPickupOutline16 = function QuickPickupOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(QuickPickupOutline16Svg, null)
  }));
};
var FeedbackOutline16 = function FeedbackOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FeedbackOutline16Svg, null)
  }));
};
var FilterOutline16 = function FilterOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(FilterOutline16Svg, null)
  }));
};
var GeolocationFilled16 = function GeolocationFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GeolocationFilled16Svg, null)
  }));
};
var GeolocationOutline16 = function GeolocationOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GeolocationOutline16Svg, null)
  }));
};
var GroceriesOutline16 = function GroceriesOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(GroceriesOutline16Svg, null)
  }));
};
var HeartOutline16 = function HeartOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HeartOutline16Svg, null)
  }));
};
var HistoryOutline16 = function HistoryOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HistoryOutline16Svg, null)
  }));
};
var HomeDeliveryOutline16 = function HomeDeliveryOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(HomeDeliveryOutline16Svg, null)
  }));
};
var IdOutline16 = function IdOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(IdOutline16Svg, null)
  }));
};
var InfoFilled16 = function InfoFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(InfoFilled16Svg, null)
  }));
};
var InfoOutline16 = function InfoOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(InfoOutline16Svg, null)
  }));
};
var InstagramOutline = function InstagramOutline(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(InstagramOutlineSvg, null)
  }));
};
var LinkOutline16 = function LinkOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LinkOutline16Svg, null)
  }));
};
var LoadingOutline16 = function LoadingOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LoadingOutline16Svg, null)
  }));
};
var LocateFilled16 = function LocateFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocateFilled16Svg, null)
  }));
};
var LocateOutline16 = function LocateOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocateOutline16Svg, null)
  }));
};
var LocationMapOutline16 = function LocationMapOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocationMapOutline16Svg, null)
  }));
};
var LocationMapFilled16 = function LocationMapFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocationMapFilled16Svg, null)
  }));
};
var LocationFilled16 = function LocationFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocationFilled16Svg, null)
  }));
};
var LocationOutline16 = function LocationOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LocationOutline16Svg, null)
  }));
};
var LockFilled16 = function LockFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(LockFilled16Svg, null)
  }));
};
var MapListOutline16 = function MapListOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MapListOutline16Svg, null)
  }));
};
var MapOutline16 = function MapOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MapOutline16Svg, null)
  }));
};
var MinusOutline16 = function MinusOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(MinusOutline16Svg, null)
  }));
};
var ModifyOrderOutline16 = function ModifyOrderOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ModifyOrderOutline16Svg, null)
  }));
};
var NaviOutline16 = function NaviOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(NaviOutline16Svg, null)
  }));
};
var NewOutline16 = function NewOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(NewOutline16Svg, null)
  }));
};
var OpeningHoursOutline16 = function OpeningHoursOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(OpeningHoursOutline16Svg, null)
  }));
};
var PhoneOutline16 = function PhoneOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PhoneOutline16Svg, null)
  }));
};
var PlusOutline16 = function PlusOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PlusOutline16Svg, null)
  }));
};
var PreventReplacementOutline16 = function PreventReplacementOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(PreventReplacementOutline16Svg, null)
  }));
};
var RadioActiveOutline16 = function RadioActiveOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RadioActiveOutline16Svg, null)
  }));
};
var RadioInactiveOutline16 = function RadioInactiveOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RadioInactiveOutline16Svg, null)
  }));
};
var ReceiptOutline16 = function ReceiptOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ReceiptOutline16Svg, null)
  }));
};
var ReloadOutline16 = function ReloadOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ReloadOutline16Svg, null)
  }));
};
var ReplaceOutline16 = function ReplaceOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ReplaceOutline16Svg, null)
  }));
};
var RestaurantOutline16 = function RestaurantOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RestaurantOutline16Svg, null)
  }));
};
var RiskIndicatorEmptyOutline16 = function RiskIndicatorEmptyOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RiskIndicatorEmptyOutline16Svg, null)
  }));
};
var RiskIndicatorFilled16 = function RiskIndicatorFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(RiskIndicatorFilled16Svg, null)
  }));
};
var SCardOutline16 = function SCardOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SCardOutline16Svg, null)
  }));
};
var SearchOutline16 = function SearchOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SearchOutline16Svg, null)
  }));
};
var SettingsOutline16 = function SettingsOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SettingsOutline16Svg, null)
  }));
};
var SizeReduction16 = function SizeReduction16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SizeReduction16Svg, null)
  }));
};
var SmartListOutline16 = function SmartListOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SmartListOutline16Svg, null)
  }));
};
var StarFilled16 = function StarFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(StarFilled16Svg, null)
  }));
};
var StarOutline16 = function StarOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(StarOutline16Svg, null)
  }));
};
var StoreOutline16 = function StoreOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(StoreOutline16Svg, null)
  }));
};
var SunOutline16 = function SunOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SunOutline16Svg, null)
  }));
};
var ThreeDotsHorizontalFilled16 = function ThreeDotsHorizontalFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ThreeDotsHorizontalFilled16Svg, null)
  }));
};
var ThreeDotsHorizontalOutline16 = function ThreeDotsHorizontalOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ThreeDotsHorizontalOutline16Svg, null)
  }));
};
var ThreeDotsVerticalFilled16 = function ThreeDotsVerticalFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ThreeDotsVerticalFilled16Svg, null)
  }));
};
var ThreeDotsVerticalOutline16 = function ThreeDotsVerticalOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(ThreeDotsVerticalOutline16Svg, null)
  }));
};
var TextAreaOutline16 = function TextAreaOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(TextAreaOutline16Svg, null)
  }));
};
var UserFilled16 = function UserFilled16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(UserFilled16Svg, null)
  }));
};
var UserOutline16 = function UserOutline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(UserOutline16Svg, null)
  }));
};
var Co2Outline16 = function Co2Outline16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(Co2Outline16Svg, null)
  }));
};
var SortingAscending16 = function SortingAscending16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SortingAscending16Svg, null)
  }));
};
var SortingDescending16 = function SortingDescending16(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({}, props, {
    svg: /*#__PURE__*/React__default.createElement(SortingDescending16Svg, null)
  }));
};

export { AlertOutline16, ArrowDownOutline16, ArrowLeftOutline16, ArrowRightOutline16, ArrowUpOutline16, BadgeFilled16, CalendarOutline16, CancelledFilled16, CategoryOutline16, ChangeOutline16, CheckboxEmptyOutline16, CheckboxMarkedFilled16, CheckboxMarkedOutline16, ChecklistOutline16, CheckmarkOutline16, ChevronBackOutline16, ChevronDownOutline16, ChevronForwardOutline16, ChevronUpOutline16, ClearFilled16, ClearOutline16, Co2Outline16, CommentFilled16, CommentOutline16, ConfirmedFilled16, CopyOutline16, CustomerServiceOutline16, DeleteOutline16, DeliveryMethodOutline16, DeliveryOutline16, DuplicationOutline16, EditOutline16, EmailOutline16, ErrorFilled16, EyeOutline16, FacebookFilled16, FastTrackOutline16, FeedbackOutline16, FilterOutline16, GeolocationFilled16, GeolocationOutline16, GroceriesOutline16, HeartOutline16, HistoryOutline16, HomeDeliveryOutline16, IdOutline16, InfoFilled16, InfoOutline16, InstagramOutline, LinkOutline16, LoadingOutline16, LocateFilled16, LocateOutline16, LocationFilled16, LocationMapFilled16, LocationMapOutline16, LocationOutline16, LockFilled16, MapListOutline16, MapOutline16, MinusOutline16, ModifyOrderOutline16, NaviOutline16, NewOutline16, OpeningHoursOutline16, PhoneOutline16, PlusOutline16, PreventReplacementOutline16, QuickPickupOutline16, RadioActiveOutline16, RadioInactiveOutline16, ReceiptOutline16, ReloadOutline16, ReplaceOutline16, RestaurantOutline16, RiskIndicatorEmptyOutline16, RiskIndicatorFilled16, SCardOutline16, SearchOutline16, SettingsOutline16, SizeReduction16, SmartListOutline16, SortingAscending16, SortingDescending16, StarFilled16, StarOutline16, StoreOutline16, SunOutline16, TextAreaOutline16, ThreeDotsHorizontalFilled16, ThreeDotsHorizontalOutline16, ThreeDotsVerticalFilled16, ThreeDotsVerticalOutline16, UserFilled16, UserOutline16 };
//# sourceMappingURL=index.js.map
